import { useMemo } from "react";
import { motion } from "framer-motion";

export const AmbientParticles = ({ count = 16 }) => {
  const particles = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: Math.random() * 2.5 + 1.2,
        duration: Math.random() * 10 + 9,
        delay: Math.random() * 6,
        drift: Math.random() * 70 + 40,
      })),
    [count]
  );

  return (
    <div className="absolute inset-0 -z-10 overflow-hidden" aria-hidden="true">
      {particles.map((p) => (
        <motion.span
          key={p.id}
          className="absolute rounded-full bg-champagne"
          style={{ left: `${p.left}%`, top: `${p.top}%`, width: p.size, height: p.size }}
          animate={{ y: [0, -p.drift, 0], opacity: [0, 0.7, 0] }}
          transition={{ duration: p.duration, repeat: Infinity, delay: p.delay, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
};
